import { Pipe, PipeTransform } from '@angular/core';
import { ProductConfigService } from '@shared/core';
import { ProductConfiguration } from '@shared/core/types';
import { EServiceTypeKey } from '@skyeng/libs/shared/stk';

@Pipe({
  name: 'productConfig',
})
/** @deprecated */
export class ProductConfigPipe implements PipeTransform {
  constructor(private productConfigService: ProductConfigService) {}

  transform<TKey extends keyof ProductConfiguration>(
    stk: EServiceTypeKey | string,
    fieldPath: TKey | [TKey] | string | any,
    defaultValue = '',
  ): string | ProductConfiguration[TKey] | undefined | null | any {
    return this.productConfigService.getFieldByStk(stk, fieldPath, defaultValue);
  }
}
